if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        const spinner =
          this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData =
          new FormData(this.form);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
          );

          formData.append(
            'sections_url',
            window.location.pathname
          );

          this.cart.setActiveElement(
            document.activeElement
          );
        }

        config.body = formData;

        const variantId =
          formData.get('id');

        const quantity =
          parseInt(formData.get('quantity')) || 1;

        const linesUpdateDeferred =
          this.createCartLinesUpdateEvent(
            variantId,
            quantity
          );

        /*
         * Check whether Gift Wrapping was selected.
         */

        const giftWrapCheckbox =
          document.querySelector(
            '#my-gift-wrap-checkbox'
          );

        const giftWrapSelected =
          giftWrapCheckbox &&
          giftWrapCheckbox.checked;

        /*
         * Add the Mystery Shirt normally using
         * Dawn's standard Shopify request.
         */

        fetch(`${routes.cart_add_url}`, config)
          .then((response) =>
            response.json()
          )

          .then(async (response) => {

            /*
             * Shopify returned an error.
             */

            if (response.status) {
              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',
                  productVariantId:
                    variantId,
                  errors:
                    response.errors ||
                    response.description,
                  message:
                    response.message,
                }
              );

              this.handleErrorMessage(
                response.description
              );

              this.dispatchCartErrorEvent(
                response.description ||
                  response.message,
                'INVALID'
              );

              linesUpdateDeferred?.reject(
                new Error(
                  response.description ||
                    response.message
                )
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) return;

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              this.submitButtonText.classList.add(
                'hidden'
              );

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            }

            /*
             * No cart drawer.
             */

            if (!this.cart) {
              this.resolveCartLinesUpdate(
                linesUpdateDeferred
              );

              /*
               * If Gift Wrapping is selected,
               * add it before going to the cart.
               */

              if (giftWrapSelected) {
                await this.addGiftWrapping(
                  quantity
                );
              }

              window.location =
                window.routes.cart_url;

              return;
            }

            /*
             * Resolve Dawn's normal cart update.
             */

            this.resolveCartLinesUpdate(
              linesUpdateDeferred
            );

            /*
             * =====================================================
             * GIFT WRAPPING
             * =====================================================
             *
             * The Mystery Shirt has now been successfully added.
             *
             * If Gift Wrapping is selected, add the Gift Wrapping
             * product separately.
             */

            if (giftWrapSelected) {
              try {
                await this.addGiftWrapping(
                  quantity
                );

                /*
                 * The original Dawn response only contains the
                 * cart state BEFORE Gift Wrapping was added.
                 *
                 * Therefore fetch the current cart drawer sections
                 * AFTER Gift Wrapping has been added.
                 */

                const sectionIds =
                  this.cart
                    .getSectionsToRender()
                    .map(
                      (section) => section.id
                    );

                const sectionsUrl =
                  `${window.location.pathname}?sections=${sectionIds.join(',')}`;

                const sectionsResponse =
                  await fetch(
                    sectionsUrl
                  );

                const sections =
                  await sectionsResponse.json();

                /*
                 * Build a fresh response for Dawn's
                 * renderContents() function.
                 */

                response.sections =
                  sections;

              } catch (giftError) {
                console.error(
                  'Gift Wrapping Error:',
                  giftError
                );

                /*
                 * The Mystery Shirt has still been added,
                 * so don't prevent the customer from continuing.
                 */
              }
            }

            /*
             * =====================================================
             * NORMAL DAWN CART UPDATE
             * =====================================================
             */

            const startMarker =
              CartPerformance.createStartingMarker(
                'add:wait-for-subscribers'
              );

            if (!this.error) {
              publish(
                PUB_SUB_EVENTS.cartUpdate,
                {
                  source: 'product-form',
                  productVariantId:
                    variantId,
                  cartData:
                    response,
                }
              ).then(() => {
                CartPerformance.measureFromMarker(
                  'add:wait-for-subscribers',
                  startMarker
                );
              });
            }

            this.error = false;

            /*
             * Quick Add modal.
             */

            const quickAddModal =
              this.closest(
                'quick-add-modal'
              );

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      'add:paint-updated-sections',
                      () => {
                        this.cart.renderContents(
                          response
                        );
                      }
                    );
                  });
                },
                {
                  once: true,
                }
              );

              quickAddModal.hide(true);

            } else {

              /*
               * Standard product page.
               */

              CartPerformance.measure(
                'add:paint-updated-sections',
                () => {
                  this.cart.renderContents(
                    response
                  );
                }
              );
            }
          })

          .catch((e) => {
            console.error(e);

            this.dispatchCartErrorEvent(
              e.message ||
                'Network error',
              'SERVICE_UNAVAILABLE'
            );

            this.handleErrorMessage(
              e.message ||
                'Unable to add the product to your cart.'
            );

            linesUpdateDeferred?.reject(
              e
            );
          })

          .finally(() => {
            this.submitButton.classList.remove(
              'loading'
            );

            if (
              this.cart &&
              this.cart.classList.contains(
                'is-empty'
              )
            ) {
              this.cart.classList.remove(
                'is-empty'
              );
            }

            if (!this.error) {
              this.submitButton.removeAttribute(
                'aria-disabled'
              );
            }

            if (spinner) {
              spinner.classList.add(
                'hidden'
              );
            }

            CartPerformance.measureFromEvent(
              'add:user-action',
              evt
            );
          });
      }

      /*
       * =========================================================
       * ADD GIFT WRAPPING
       * =========================================================
       */

      async addGiftWrapping(quantity) {

        /*
         * Find the Gift Wrapping product using its handle.
         */

        const productResponse =
          await fetch(
            `${window.Shopify.routes.root}products/gift-wrapping-mystery-shirt-box.js`
          );

        if (!productResponse.ok) {
          throw new Error(
            'Unable to find the Gift Wrapping product.'
          );
        }

        const product =
          await productResponse.json();

        if (
          !product ||
          !product.variants ||
          !product.variants.length
        ) {
          throw new Error(
            'No Gift Wrapping variant was found.'
          );
        }

        const giftWrapVariant =
          product.variants[0];

        /*
         * Add the exact same quantity as
         * the Mystery Shirt.
         */

        const giftWrapResponse =
          await fetch(
            `${window.Shopify.routes.root}cart/add.js`,
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                'X-Requested-With':
                  'XMLHttpRequest'
              },

              body: JSON.stringify({
                items: [
                  {
                    id: Number(
                      giftWrapVariant.id
                    ),

                    quantity:
                      quantity
                  }
                ]
              })
            }
          );

        const giftWrapData =
          await giftWrapResponse.json();

        if (!giftWrapResponse.ok) {
          throw new Error(
            giftWrapData.description ||
              giftWrapData.message ||
              'Unable to add Gift Wrapping.'
          );
        }

        return giftWrapData;
      }

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (text) {
            this.submitButtonText.textContent =
              text;
          }
        } else {
          this.submitButton.removeAttribute(
            'disabled'
          );

          this.submitButtonText.textContent =
            window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(
        variantId,
        quantity
      ) {
        const {
          CartLinesUpdateEvent
        } =
          window.StandardEvents || {};

        if (!CartLinesUpdateEvent) {
          return null;
        }

        const deferred =
          CartLinesUpdateEvent.createPromise();

        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',

            lines: [
              {
                merchandiseId:
                  variantId,
                quantity
              }
            ],

            promise:
              deferred.promise
          })
        );

        return deferred;
      }

      resolveCartLinesUpdate(
        deferred
      ) {
        if (!deferred) return;

        const {
          CartLinesUpdateEvent
        } =
          window.StandardEvents || {};

        if (!CartLinesUpdateEvent) {
          return;
        }

        const pendingCartDataPromise =
          typeof CartItems !==
          'undefined'
            ? CartItems.fetchCartData()
            : fetch(
                `${routes.cart_url}.json`
              ).then(
                (response) =>
                  response.json()
              );

        pendingCartDataPromise

          .then((cart) => {

            if (!cart?.currency) {
              return deferred.reject(
                new Error(
                  'Missing currency in cart response'
                )
              );
            }

            deferred.resolve({
              cart:
                CartLinesUpdateEvent.createCartFromAjaxResponse(
                  cart
                )
            });

          })

          .catch((e) =>
            deferred.reject(e)
          );
      }

      dispatchCartErrorEvent(
        message,
        code
      ) {
        const {
          CartErrorEvent
        } =
          window.StandardEvents || {};

        if (!CartErrorEvent) {
          return;
        }

        this.dispatchEvent(
          new CartErrorEvent({
            error: message,
            code
          })
        );
      }

      get variantIdInput() {
        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}